import { registerSecondScreenCode } from 'Api/ProfileApi';
import { SET_SECOND_SCREEN, RESET_SECOND_SCREEN } from '../Types';

export const setSecondScreen = (payload) => ({ type: SET_SECOND_SCREEN, payload });
export const resetSecondScreen = () => ({ type: RESET_SECOND_SCREEN });

export const registerSecondScreen = () => async (dispatch, getState) => {
  const {
    secondScreen: { code },
  } = getState();

  await registerSecondScreenCode(code);
  dispatch(resetSecondScreen());
};
